const state={
  show:false,
  percent:0
}
const getters={
  getshow:state=>state.show,
  getpercent:state=>state.percent
}
const mutations={
  newShow:(state,data)=>{
    state.show=data.show
  },
  newpercent:(state,data)=>{
    state.percent=data.percent
  }
}
export default {
  state,
  getters,
  mutations
};
